import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { type LinearConfigurationDTO } from "~/features/configurator/Linear/dtos";
import { transform } from "~/features/configurator/Linear/linearDataTransformer";
import type { ConfiguratorUpdateCommand } from "~/features/configurator/common/api/configuratorCommands";
import { postConfiguratorCommand } from "~/features/configurator/common/api/configuratorCommandApi";
import type { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";

export async function sendShaft(
  apiData: ConfiguratorUpdateCommand,
  configuratorType: ConfiguratorType,
): Promise<LinearConfiguration> {
  const response = await postConfiguratorCommand<LinearConfigurationDTO>(
    "/shaft/getconfig",
    apiData,
    "sending shaft update",
  );
  return transform(response, configuratorType, undefined);
}
